import {
    DEFAULT_DYNAMIC_EVALUATION_TIME,
    DEFAULT_DYNAMIC_SUBMISSION_TIME,
} from '../../../components/admin/timelines/timelineConstants';
import {
    GeneralAppSettingsAction,
    GeneralAppSettingsType,
} from '../../actionTypes/settings/generalAppSettings';
import { GeneralAppSettings } from '../../types';

const GENERAL_APP_SETTINGS_INITIAL_STATE: GeneralAppSettings = {
    logoFilename: '',
    logoLink: '',
    organizationName: '',
    generalTimelineSettings: {
        defaultNumberOfEvaluationDays: DEFAULT_DYNAMIC_EVALUATION_TIME,
        defaultNumberOfSubmissionTimeDays: DEFAULT_DYNAMIC_SUBMISSION_TIME,
    },
    isPublishingProjectsAllowed: false,
};
const reducer = (
    state: GeneralAppSettings = GENERAL_APP_SETTINGS_INITIAL_STATE,
    action: GeneralAppSettingsAction
): GeneralAppSettings => {
    let organizationName: string;
    let generalTimelineSettings: {
        defaultNumberOfEvaluationDays: number;
        defaultNumberOfSubmissionTimeDays: number;
    };
    switch (action.type) {
        case GeneralAppSettingsType.GET_GENERAL_APP_SETTINGS:
        case GeneralAppSettingsType.UPDATE_GENERAL_APP_SETTINGS:
            organizationName = action.payload.organizationName
                ? action.payload.organizationName
                : action.localization.localizationStrings.susy.general
                      .yourOrganization;
            generalTimelineSettings = {
                defaultNumberOfEvaluationDays: action.payload
                    .generalTimelineSettings?.defaultNumberOfEvaluationDays
                    ? action.payload.generalTimelineSettings
                          ?.defaultNumberOfEvaluationDays
                    : DEFAULT_DYNAMIC_EVALUATION_TIME,
                defaultNumberOfSubmissionTimeDays: action.payload
                    .generalTimelineSettings?.defaultNumberOfSubmissionTimeDays
                    ? action.payload.generalTimelineSettings
                          ?.defaultNumberOfSubmissionTimeDays
                    : DEFAULT_DYNAMIC_SUBMISSION_TIME,
            };
            return {
                ...action.payload,
                logoLink: state.logoLink,
                organizationName,
                generalTimelineSettings,
            };
        case GeneralAppSettingsType.GET_LOGO_IMAGE_URL:
            return { ...state, logoLink: action.payload };
        default:
            return state;
    }
};
export default reducer;
